import React from 'react';
import { get } from 'lodash-es';

import { ScaleContainer } from './scale-container';
import { emptyObject } from 'ui-components/default-props/empty';
import { BulkActions } from '../../../../enums/bulk-actions';
import { BulkConvertedWeightField } from '../../../converted-weight-input/bulk-converted-weight-field';
import style from '../bulk-actions.module.less';

export const Weight = {
  id: BulkActions.weight.name,

  render: (onChange, model) => {
    const shippingConfiguration = get(model, 'shippingConfiguration', emptyObject);
    const firstPackage = get(shippingConfiguration, 'packages.0', emptyObject);
    const weight = get(firstPackage, 'weight', emptyObject);
    const updatePackageWeight = (newWeight, unit) => {
      onChange({
        ...model,
        shippingConfiguration: {
          ...shippingConfiguration,
          packages: [
            {
              ...firstPackage,
              weight: {
                weight: newWeight,
                weightUnit: unit,
              },
            },
          ],
        },
      });
    };
    return (
      <div className={style['content-width']}>
        <BulkConvertedWeightField onChange={updatePackageWeight} renderScale={() => <ScaleContainer />} weight={weight} />
      </div>
    );
  },
};
